import BeginRunAuto from './BeginRunAuto';

export default BeginRunAuto;
